module.exports = __webpack_public_path__ + "img/magento.43b6d34c.jpg";